import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Stack,
} from "@mui/material";
import templeIcon from "../../../assets/temple-icon.png";
import { KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon } from "@mui/icons-material";

import "./PujaListCard.scss";
import { useSelector } from "react-redux";
import {
  getCityStateFromTemple,
  getConcatenatedTempleNames,
  getOfferPriceFromV1,
  getTempleName,
} from "../../../utils/HelperFunctions";
import { LOCALIZATION } from "../../../utils/localization";
import { useTranslation } from "react-i18next";
import { LOCALSTORAGE_KEY, orderType } from "../../../utils/Constants";
import ImageView from "../../ImageView/ImageView";
import OverlayText from "../../OverlayText/overlayText";
import {
  CALENDAR_ICON,
  TD_VERIFIED_BADGE,
} from "../../../utils/imageConstants";
import BoldText from "../../boldText/BoldText";

export default function PujaListCard(props: any) {
  const { t } = useTranslation();
  const {
    pujaData,
    benefitList,
    temple,
    templeProfilePic,
    pujaName,
    onClickAddPuja,
    isPujaDisable,
    isPromotionalPuja = false,
    devoteeCount,
    leftSideTextOverlay,
    rightSideTextOverlay,
  } = props;

  const [pujaInfo, setPujaInfo] = useState<any>(null);
  const [staticPrice, setStaticPrice] = useState<any>(0);
  const [bnftText, setBnftText] = useState("");
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
    platformFeeForChadhava,
  } = priceConversionState.priceConversionRate || {};

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName({ personalInfo: temple }, savedLanguage);
  const packageTempleName = getConcatenatedTempleNames(
    pujaData?.pujaDetails?.templeList
  );
  const templeFinalName = templeName ? templeName : packageTempleName;
  const templeAddress = getCityStateFromTemple(temple);

  useEffect(() => {
    let pujaDetails: any;
    if (pujaData) {
      if (isPromotionalPuja) {
        pujaDetails = pujaData;
      } else {
        pujaDetails = pujaData?.pujaDetails;
      }
      setPujaInfo(pujaDetails);
    }
  }, [pujaData]);

  useEffect(() => {
    let fixedPrice = 0;
    if (pujaInfo?.overseasBasicPrice || pujaInfo?.indianBasicPrice) {
      fixedPrice = isOverseas
        ? pujaInfo?.overseasBasicPrice
        : pujaInfo?.indianBasicPrice;
      fixedPrice = parseFloat(Number(fixedPrice * rate).toFixed(2)) || 0.0;
      setStaticPrice(fixedPrice);
    }
  }, [rate, pujaInfo?.id, isOverseas]);

useEffect(() => {
  if (!benefitList || benefitList?.length === 0) {
    setBnftText("");
    return;
  }

  const benifitText = benefitList?.map((item: any) => item?.name)?.join(" | ");

  setBnftText(benifitText);
}, [benefitList]);

  const offerV1 =
    pujaInfo?.type === orderType.pujaPackage
      ? pujaInfo?.priceBreakupV1
      : pujaInfo?.multiplePujaDetails?.length
      ? pujaInfo?.multiplePujaDetails[0]?.priceBreakupV1
      : null;
  const offerPriceToShow = getOfferPriceFromV1(
    offerV1,
    isOverseas,
    false,
    rate
  );

  return (
    <Box className="pujaAreaCard puja-list-card-component" onClick={() => onClickAddPuja(pujaData)}>
      <Box className="card-body">
        <Box className="pujaImg">
          <ImageView src={templeProfilePic} alt="templeProfilePic" />
          {/* <Badge className="devoteeBadge">
          <Box className="badgeIcon">
            <img src={devoteeIcon} alt="" />
          </Box>
          <Box className="badgeText">
            <Typography>{`${t(LOCALIZATION.Upto)} ${devoteeCount ?? 1} ${t(
              LOCALIZATION.devotees
            )} `}</Typography>
          </Box>
        </Badge> */}
          <OverlayText
            leftSideTextOverlay={leftSideTextOverlay}
            rightSideTextOverlay={rightSideTextOverlay}
            overlayCss={pujaInfo?.overlayCss ?? null}
          />
        </Box>
        <Box className="specialTextSec">
          <Box
            component="img"
            className="verifiedBadge"
            src={TD_VERIFIED_BADGE}
            alt="Verified Badge"
          />
          <Typography
            className="specialText"
            sx={{
              display:
                pujaInfo?.type === orderType.pujaPackage
                  ? pujaInfo?.cardTitle
                    ? "block"
                    : "none"
                  : pujaInfo?.pujaSpecialDesc
                  ? "block"
                  : "none",
            }}
          >
            {pujaInfo?.type === orderType.pujaPackage
              ? pujaInfo?.cardTitle || ""
              : pujaInfo?.pujaSpecialDesc || ""}
          </Typography>
        </Box>
        <Box className="cardTitle">
          <Typography className="mainPujaTitle">{pujaName}</Typography>
          <Typography className="subTitle">{bnftText}</Typography>
        </Box>

        <Box className="pujaDescription">
          <List>
            <ListItem>
              <ListItemAvatar sx={{ minWidth: "35px" }}>
                <Avatar alt="Temple Icon" className="squreShape temple">
                  <img src={templeIcon} alt="temple"></img>
                </Avatar>
              </ListItemAvatar>
              <Typography variant="body1" className="templeNameText">
                {templeFinalName}{" "}
                {templeAddress?.trim().length > 0 && `, ${templeAddress}`}
              </Typography>
            </ListItem>
            {pujaInfo?.tithiName && (
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Calendar Icon" className="squreShape calendar">
                    <img
                      src={CALENDAR_ICON}
                      alt="calendar"
                    ></img>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<BoldText text={pujaInfo?.tithiName || ""} />}
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Box>
      <Box className="bottomSection">
        {staticPrice > 0 && (
          <Typography className="gstSavingsText">
            {t(LOCALIZATION.GST_TEXT_Card)}
          </Typography>
        )}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          {staticPrice > 0 && (
            <Stack
              direction="row"
              alignItems="flex-end"
              className="pujaStartPrice"
            >
              <Stack
                direction="column"
                alignItems="flex-start"
                className="pujaStartPriceColumn"
              >
                {offerPriceToShow > 0 && (
                  <Typography className="cuttedPrice">
                    {currencySymbols}{offerPriceToShow}
                  </Typography>
                )}
                <Box display="flex" alignItems="baseline">
                  <Typography className="rupeeSign">
                    {currencySymbols}
                  </Typography>
                  <Typography className="priceAmount">{staticPrice}</Typography>
                </Box>
              </Stack>
              <Box>
                <Typography ml={1}>{t(LOCALIZATION.Price_Starts)}</Typography>
              </Box>
            </Stack>
          )}
          <Button
            variant="contained"
            aria-label="Book"
            endIcon={<KeyboardDoubleArrowRightIcon />}
            className="cardLastBtn"
            onClick={() => onClickAddPuja(pujaData)}
            disabled={isPujaDisable}
          >
            {pujaInfo?.type === orderType.pujaPackage
              ? t(LOCALIZATION.Book_Package)
              : t(LOCALIZATION.View_to_participate)}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
